import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Toast } from 'primereact/toast';
import { Box, Button, IconButton, Skeleton, Tooltip, Typography } from "@mui/material";
import { useEffect } from 'react';
import { useState } from 'react';
import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useDateformate, useGetBatchHistory } from '../Components/globalFunctions';
import { updateInventoryDetail, updateinventoryDetailsEdit, updateInventoryDetailsModal, updateSelectedBatchNo } from '../Redux/inventory';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import CustomAxios from '../utils/CustomAxios';
import { ReturnRequestModal } from '../Components/ReturnRequestModal';

export function BatchViewTable() {
    const toast = useRef(null);
    const user_id = useSelector( state => state.user.id)
    const selectedBatch = useSelector(state => state.inventory.selectedBatchNo)
    const searchBatchProduct = useSelector(state => state.inventory.searchBatchProduct)
    const batchHistoryLoading = useSelector(state => state.inventory.batchHistoryLoading)
    const formatdate = useDateformate()
    const getBatchHistory = useGetBatchHistory()
    const dispatch = useDispatch()
    
    const user_role = localStorage.getItem('role');
    const assignedHubs = JSON.parse(localStorage.getItem('hub') || '[]');
    const [returnRequestModal, setReturnRequestModal] = useState(false);
    const [submittingReturn, setSubmittingReturn] = useState(false);
    
    const canManageBatch = (batch) => {
        if (user_role === 'super_admin') return true; 
        if (user_role === 'admin') return true; 
        if (user_role === 'supervisor') return true; // enable supervisor edit/delete
        return false; 
    };
    // useEffect(() => {
    //     const filtered = batchHistory.filter((batch) =>
    //         console.log(batch.batch_number,selectedBatchNo) 
    //         // batch.batch_number == selectedBatchNo
    //     )
    //     setSelectedBatch(filtered)
    // }, [selectedBatchNo])
    const handleOpen = (item) => {
        console.log(item)
        dispatch(updateInventoryDetailsModal(true))
        dispatch(updateinventoryDetailsEdit(true));
        dispatch(updateInventoryDetail(item));
        // setErrors({})
    };
    console.log(selectedBatch)
      const confirmDelete = (item) => {
        console.log(item)
        confirmDialog({
          message: (
            <Box sx={{ display: "flex", gap: "10px", flexDirection: "column" }}>
              <Typography sx={{ fontSize: "16px", fontWeight: 500 }}>
                Do you want to delete this Batch detail
              </Typography>
            </Box>
          ),
          header: "Delete Confirmation",
          defaultFocus: 'reject',
          acceptClassName: 'p-button-danger',
          accept: () => accept(item),
        });
      };
    
      const accept = async (batch) => {
        try {
          await CustomAxios.delete(`inventory/details/delete/${batch.batch}/`,{data:{admin_id:user_id,batch_details_id:batch.id,batch_delete:false}})
          .then(() => {
            getBatchHistory()
            dispatch(updateSelectedBatchNo({}))
            toast.current.show({
                  severity: "success",
                  summary: "Success",
                  detail: "Batch details deleted successfully",
                  life: 3000,
                });
          })
                
        } catch (err) {
          console.error("Error deleting delivery details", err);
        }
      };

    const handleRequestReturn = (batch) => {
        setReturnRequestModal(true);
    };

    const handleSubmitReturnRequest = async (requestReason) => {
        setSubmittingReturn(true);
        try {
            await CustomAxios.post(`inventory/batch/${selectedBatch.id}/return-action/`, { 
                action: 'request',
                request_reason: requestReason
            });
            toast.current.show({
                severity: "success",
                summary: "Success",
                detail: "Return request raised successfully",
                life: 3000,
            });
            setReturnRequestModal(false);
            getBatchHistory();
        } catch (err) {
            toast.current.show({
                severity: "error",
                summary: "Error",
                detail: err.response?.data?.error || "Failed to request return",
                life: 3000,
            });
        } finally {
            setSubmittingReturn(false);
        }
    };

    const handleCloseReturnModal = () => {
        setReturnRequestModal(false);
    };

    const handleCancelReturn = async (batch) => {
        confirmDialog({
            message: (
                <Box sx={{ display: "flex", gap: "10px", flexDirection: "column" }}>
                    <Typography sx={{ fontSize: "16px", fontWeight: 500 }}>
                        Cancel return request for batch {batch.batch_number}?
                    </Typography>
                    <Typography sx={{ fontSize: "14px", color: "gray" }}>
                        This will restore inventory counts back to current values.
                    </Typography>
                </Box>
            ),
            header: "Cancel Return Request",
            accept: async () => {
                try {
                    await CustomAxios.post(`inventory/batch/${batch.id}/return-action/`, { action: 'cancel' });
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Return request cancelled successfully",
                        life: 3000,
                    });
                    getBatchHistory();
                } catch (err) {
                    toast.current.show({
                        severity: "error",
                        summary: "Error",
                        detail: err.response?.data?.error || "Failed to cancel return",
                        life: 3000,
                    });
                }
            },
        });
    };

    const handleCompleteReturn = async (batch) => {
        confirmDialog({
            message: (
                <Box sx={{ display: "flex", gap: "10px", flexDirection: "column" }}>
                    <Typography sx={{ fontSize: "16px", fontWeight: 500 }}>
                        Mark batch {batch.batch_number} as returned?
                    </Typography>
                    <Typography sx={{ fontSize: "14px", color: "gray" }}>
                        This will mark the return as completed. The inventory counts have already been reduced.
                    </Typography>
                </Box>
            ),
            header: "Mark as Returned",
            accept: async () => {
                try {
                    await CustomAxios.post(`inventory/batch/${batch.id}/return-action/`, { action: 'complete' });
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Batch marked as returned successfully",
                        life: 3000,
                    });
                    getBatchHistory();
                } catch (err) {
                    toast.current.show({
                        severity: "error",
                        summary: "Error",
                        detail: err.response?.data?.error || "Failed to mark as returned",
                        life: 3000,
                    });
                }
            },
        });
    };
      console.log(selectedBatch)
    return (<Box>
        {/* <ConfirmDialog/> */}
        <Toast ref={toast} />
        
        {/* Return Request Modal */}
        <ReturnRequestModal
            open={returnRequestModal}
            onClose={handleCloseReturnModal}
            batchNumber={selectedBatch?.batch_number}
            onSubmit={handleSubmitReturnRequest}
            loading={submittingReturn}
        />

        <TableContainer sx={{ height: "100%" }}>
            <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }}>
                <TableHead style={{ backgroundColor: "background.upload" }}>
                    <TableRow >
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">S no</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Product Name</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Batch</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Quantity</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Purchased On</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Expired on</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Return Status</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Actions</TableCell>


                    </TableRow>
                </TableHead>
                <TableBody>
                    {selectedBatch?.batch?.length > 0 ?
                        selectedBatch?.batch.filter((item) => {
                            if (!item.product.item_name) return false;
                        
                            return searchBatchProduct !== ""
                              ? item.product.item_name.toLowerCase().includes(searchBatchProduct?.toLowerCase())
                              : true; }).map((item, ind) => {
                            // console.log(item)
                            return (<> {
                                <TableRow key={item.batch}>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }} >{ind + 1}</TableCell>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{item.product.item_name}</TableCell>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{selectedBatch.batch_number}</TableCell>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{item.quantity}</TableCell>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{formatdate(selectedBatch.purchased_on)}</TableCell>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{formatdate(item.expired_on)}</TableCell>
                                    <TableCell sx={{ textAlign: "left", backgroundColor: "white" }}>
                                        {(() => {
                                            const status = selectedBatch.return_status || 'active';
                                            // Only show status badge if it's not active
                                            if (status === 'active' || !status) {
                                                return (
                                                    <Typography sx={{ fontSize: "12px", color: "gray" }}>
                                                        -
                                                    </Typography>
                                                );
                                            }
                                            const statusConfig = {
                                                'request_raised': { label: 'Request Raised', color: '#FF9800', bgColor: '#FFF3E0' },
                                                'cancelled': { label: 'Cancelled', color: '#9E9E9E', bgColor: '#F5F5F5' },
                                                'returned': { label: 'Returned', color: '#F44336', bgColor: '#FFEBEE' },
                                            };
                                            const config = statusConfig[status] || statusConfig['request_raised'];
                                            return (
                                                <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                                    <Box sx={{ 
                                                        width: "8px", 
                                                        height: "8px", 
                                                        borderRadius: "50%", 
                                                        backgroundColor: config.color 
                                                    }} />
                                                    <Typography sx={{ fontSize: "12px", color: config.color, fontWeight: 500 }}>
                                                        {config.label}
                                                    </Typography>
                                                </Box>
                                            );
                                        })()}
                                    </TableCell>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white", display: "flex", gap: "8px", alignItems: "center", flexWrap: "wrap" }}>
                                        {(() => {
                                            const canManage = canManageBatch(selectedBatch);
                                            
                                            if (user_role === 'super_admin') {
                                                // Super Admin: Can edit and delete all batches
                                                return (
                                                    <>
                                                        <Tooltip title="Update" arrow>
                                                            <Button sx={{ width: "38px", height: "22px", backgroundColor: "button.backgroundEdit", border: "1px solid", borderColor: "borders.green" }} onClick={() => handleOpen(selectedBatch)}> 
                                                                <Typography sx={{ fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "borders.green" }}>Edit</Typography>
                                                            </Button>
                                                        </Tooltip>
                                                        <Tooltip title="Delete" arrow>
                                                            <Button sx={{ width: "38px", height: "22px", backgroundColor: "button.backgroundDelete", border: "1px solid", borderColor: "borders.red" }} onClick={() => confirmDelete(item)}> 
                                                                <Typography sx={{ fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "borders.red" }}>Delete</Typography>
                                                            </Button>
                                                        </Tooltip>
                                                    </>
                                                );
                                            } else if (user_role === 'admin') {
                                                // Admin: Can edit and delete only assigned hub batches
                                                if (canManage) {
                                                    return (
                                                        <>
                                                            <Tooltip title="Update" arrow>
                                                                <Button sx={{ width: "38px", height: "22px", backgroundColor: "button.backgroundEdit", border: "1px solid", borderColor: "borders.green" }} onClick={() => handleOpen(selectedBatch)}> 
                                                                    <Typography sx={{ fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "borders.green" }}>Edit</Typography>
                                                                </Button>
                                                            </Tooltip>
                                                            <Tooltip title="Delete" arrow>
                                                                <Button sx={{ width: "38px", height: "22px", backgroundColor: "button.backgroundDelete", border: "1px solid", borderColor: "borders.red" }} onClick={() => confirmDelete(item)}> 
                                                                    <Typography sx={{ fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "borders.red" }}>Delete</Typography>
                                                                </Button>
                                                            </Tooltip>
                                                        </>
                                                    );
                                                } else {
                                                    return (
                                                        <>
                                                            <Tooltip title="View Only - Not assigned to this hub" arrow>
                                                                <Button sx={{ width: "38px", height: "22px", backgroundColor: "gray", border: "1px solid", borderColor: "gray", opacity: 0.5 }} disabled> 
                                                                    <Typography sx={{ fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "white" }}>Edit</Typography>
                                                                </Button>
                                                            </Tooltip>
                                                            <Tooltip title="View Only - Not assigned to this hub" arrow>
                                                                <Button sx={{ width: "38px", height: "22px", backgroundColor: "gray", border: "1px solid", borderColor: "gray", opacity: 0.5 }} disabled> 
                                                                    <Typography sx={{ fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "white" }}>Delete</Typography>
                                                                </Button>
                                                            </Tooltip>
                                                        </>
                                                    );
                                                }
                                            } else if (user_role === 'supervisor') {
                                                // Supervisor: Now can edit and delete batches
                                                return (
                                                    <>
                                                        <Tooltip title="Update" arrow>
                                                            <Button sx={{ width: "38px", height: "22px", backgroundColor: "button.backgroundEdit", border: "1px solid", borderColor: "borders.green" }} onClick={() => handleOpen(selectedBatch)}> 
                                                                <Typography sx={{ fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "borders.green" }}>Edit</Typography>
                                                            </Button>
                                                        </Tooltip>
                                                        <Tooltip title="Delete" arrow>
                                                            <Button sx={{ width: "38px", height: "22px", backgroundColor: "button.backgroundDelete", border: "1px solid", borderColor: "borders.red" }} onClick={() => confirmDelete(item)}> 
                                                                <Typography sx={{ fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "borders.red" }}>Delete</Typography>
                                                            </Button>
                                                        </Tooltip>
                                                    </>
                                                );
                                            } else {
                                                // Other roles: No access
                                                return (
                                                    <Typography sx={{ fontSize: "12px", fontWeight: 400, color: "gray" }}>
                                                        No Access
                                                    </Typography>
                                                );
                                            }
                                        })()}
                                        {(() => {
                                            const returnStatus = selectedBatch.return_status || 'active';
                                            if (returnStatus === 'active' || returnStatus === 'cancelled') {
                                                return (
                                                    <Tooltip title="Request Return" arrow>
                                                        <Button 
                                                            sx={{ 
                                                                width: "auto", 
                                                                height: "22px", 
                                                                backgroundColor: "#FF9800", 
                                                                border: "1px solid", 
                                                                borderColor: "#FF9800",
                                                                padding: "0 8px"
                                                            }} 
                                                            onClick={() => handleRequestReturn(selectedBatch)}
                                                        >
                                                            <Typography sx={{ fontSize: "12px", fontWeight: 400, color: "white" }}>
                                                                Request Return
                                                            </Typography>
                                                        </Button>
                                                    </Tooltip>
                                                );
                                            } else if (returnStatus === 'request_raised') {
                                                return (
                                                    <>
                                                        <Tooltip title="Mark as Returned" arrow>
                                                            <Button 
                                                                sx={{ 
                                                                    width: "auto", 
                                                                    height: "22px", 
                                                                    backgroundColor: "#F44336", 
                                                                    border: "1px solid", 
                                                                    borderColor: "#F44336",
                                                                    padding: "0 8px"
                                                                }} 
                                                                onClick={() => handleCompleteReturn(selectedBatch)}
                                                            >
                                                                <Typography sx={{ fontSize: "12px", fontWeight: 400, color: "white" }}>
                                                                    Mark as Returned
                                                                </Typography>
                                                            </Button>
                                                        </Tooltip>
                                                        <Tooltip title="Cancel Return Request" arrow>
                                                            <Button 
                                                                sx={{ 
                                                                    width: "auto", 
                                                                    height: "22px", 
                                                                    backgroundColor: "#4CAF50", 
                                                                    border: "1px solid", 
                                                                    borderColor: "#4CAF50",
                                                                    padding: "0 8px"
                                                                }} 
                                                                onClick={() => handleCancelReturn(selectedBatch)}
                                                            >
                                                                <Typography sx={{ fontSize: "12px", fontWeight: 400, color: "white" }}>
                                                                    Cancel Return
                                                                </Typography>
                                                            </Button>
                                                        </Tooltip>
                                                    </>
                                                );
                                            }
                                            return null;
                                        })()}
                                    </TableCell>
                                </TableRow>}</>)
                        })
                        : <TableRow  >
                            
                                <TableCell sx={{ textAlign: "center", textTransform: "capitalize", backgroundColor: "white", height: "200px", fontWeight: "700" }} colSpan={8}>No Batch Selected</TableCell>
                        </TableRow>
                    }
                </TableBody>
            </Table>
        </TableContainer>
    </Box>)
}